import React from 'react'
import c from 'classnames'
import { connect } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
import isEqual from 'lodash/isEqual'
import { InventoryCard } from 'components/Chip'
import Icon from 'discada/dist/Icon'

import {
  initInventoryList,
  initPins,
  storeSelectedFilters,
} from 'actions/inventoryActions'

import {
  isLoading,
  getVehicleIds,
  getAllPins,
  getSelectedFilters,
} from 'selectors/inventorySelectors'

import { VlpTour } from 'components/widgets/Tour'

import { getActiveQuery, getQueryValue } from 'selectors/pageStateSelectors'
import { getRooftopConfigGroup } from 'selectors/appStatusSelectors'
import { trackVlpView } from 'actions/naughtyActions'
import { Fader } from 'pages/inventory/widgets'

import InventoryControls from './InventoryControls'

import './index.scss'

export class InventoryList extends React.Component {
  constructor(...args) {
    super(...args)

    this.state = {
      tourOk: false,
      showTour: false,
      showAllSearch: true,
      pins: {},
    }

    this.toggle = () =>
      this.setState({ showAllSearch: !this.state.showAllSearch })

    this.setUpPins = () => {
      this.props.initPins(this.props.pins)
    }

    this.toggleTour = () => {
      try {
        localStorage.removeItem('tour-vlp-tour')

        this.setState({ showTour: true }, () =>
          setTimeout(() => this.setState({ showTour: false }), 1),
        )
      } catch (e) {
        console.warn(e)
      }
    }
  }

  componentDidMount() {
    let { isShowingVehicle, initInventoryList } = this.props

    this.setUpPins()
    !isShowingVehicle && initInventoryList()

    this.props.trackVlpView()
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(this.props.selectedFilters, prevProps.selectedFilters))
      this.props.trackVlpView()

    if (!this.props.isLoading && prevProps.isLoading)
      this.setState({ tourOk: true })

    if (!isEqual(this.props.pins, prevProps.pins)) this.setUpPins()
  }

  render() {
    let { vehicleIds, isLoading, pins, filtersOpen } = this.props,
      { showAllSearch } = this.state

    return (
      <div className={c('frikin-dashboard', { loading: isLoading })}>
        <InventoryControls toggleTour={this.toggleTour} />

        {!filtersOpen && (
          <div className="inventory-inner">
            <div className="inventory-loading-mask" />

            {!isEmpty(pins) && (
              <div
                className={c('pins-list', {
                  'pins-list-active': !isEmpty(pins) > 0,
                })}
              >
                <h2>
                  <Icon icon="thumbtack" /> Your Pinned Vehicles
                </h2>

                {Object.keys(pins).map(k => (
                  <Fader className="inventory-chip-wrapper" key={k}>
                    <InventoryCard id={k} quoteId={pins[k]} showPin />
                  </Fader>
                ))}
              </div>
            )}

            <div className={c('vehicles-list')}>
              {showAllSearch &&
                (vehicleIds.length > 0 || isLoading ? (
                  vehicleIds.map(id => (
                    <Fader className="inventory-chip-wrapper" key={id}>
                      <InventoryCard id={id} showPin />
                    </Fader>
                  ))
                ) : (
                  <h3>No Matches for your search.</h3>
                ))}
            </div>
          </div>
        )}

        {false && !filtersOpen && this.state.tourOk && (
          <VlpTour reset={this.state.showTour} />
        )}
      </div>
    )
  }
}

function mapStateToProps(state, op) {
  let allVehicleIds = getVehicleIds(state)

  return {
    ...op,
    pins: getAllPins(state),
    isLoading: isLoading(state),
    trueResultsCount: allVehicleIds.length,
    vehicleIds: allVehicleIds,
    isShowingVehicle: !!getActiveQuery(state).vehicleId,
    hasQuoteConfig: !isEmpty(getRooftopConfigGroup(state, 'quote')),
    selectedFilters: getSelectedFilters(state),
    filtersOpen: getQueryValue(state, 'filtersOpen'),
  }
}

export default connect(
  mapStateToProps,
  {
    trackVlpView,
    initInventoryList,
    initPins,
    storeSelectedFilters,
  },
)(InventoryList)
